import { type VariantProps, cva } from 'class-variance-authority'
import type { ComponentPropsWithoutRef } from 'react'

export const iconVariants = cva('block', {
  variants: {
    size: {
      12: 'min-h-3 min-w-3',
      16: 'min-h-4 min-w-4',
      20: 'min-h-5 min-w-5',
      24: 'min-h-6 min-w-6',
      28: 'min-h-7 min-w-7',
      32: 'min-h-8 min-w-8',
      36: 'min-h-9 min-w-9',
      48: 'min-h-12 min-w-12',
    },
    direction: {
      left: '[&_[data-direction]]:rotate-180',
      down: '[&_[data-direction]]:rotate-90',
      up: '[&_[data-direction]]:-rotate-90',
      right: '[&_[data-direction]]:rotate-0',
    },
    mirror: {
      x: '[&_[data-mirror]]:scale-x-[-1]',
      y: '[&_[data-mirror]]:scale-y-[-1]',
      both: '[&_[data-mirror]]:scale-[-1]',
    },
  },
})

export type IconSize = NonNullable<VariantProps<typeof iconVariants>['size']>

export interface IconProps extends ComponentPropsWithoutRef<'svg'>, VariantProps<typeof iconVariants> {
  size?: IconSize
  direction?: 'left' | 'down' | 'up' | 'right'
  mirror?: 'x' | 'y' | 'both'
}
